module.exports = "/_next/static/images/08a53459886811064d64e2d39a74de99-NU_ComplianceTeam_ParkerLogo-08 1_md.png.webp";